export const locale = {
  lang: "fr-CA",
  data: {
    SELECT_PLACE: {
      TITLE: "Sélectionner une salle interne",
      SELECTED_ROOM: "Salle sélectionné",
    },
  },
};
